import React, { useEffect } from "react";
import { useState } from "react";

import {
  ButtonWrapper,
  Heading2,
  Heading3,
  PageContainer,
  PageSection,
  ParagraphText,
  PrimaryButtonLink,
  DisplayTableWrapper,
  TableBody,
  DisplayTableCell,
  DisplayTableHead,
  DisplayTableHeaderCell,
  DisplayTableRow,
  InlineButton,
  ActionButtonBarWrapper
} from "../../UIKit/styles";

import { LoadingModal } from "../../Components";

import { useNavigate } from "react-router";
import { CLONE_STATUS_INITIALISE, DELETE_STATUS_INITIALISE } from "../../constants";

export default function Summary({
  initialiseCalculation,
  orchardData,
  loading,
  getResultsData,
  setModalOpen,
  setselectedOrchard,
  setActionStatus,
  resumeDraft,
  setClonedKpinName
}) {

  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const navigateToResult = async (shareId, kpin) => {
    await getResultsData(shareId, kpin);

    navigate(`../results?shareId=${shareId}&kpin=${kpin}`);
  };

  const getOrchardTableData = () => {
    if (!orchardData || orchardData?.length === 0) {
      return (
        <PageSection>
          <Heading3 data-testid="orchard-results-heading">
            No orchards have been created yet.
          </Heading3>
        </PageSection>
      );
    }

    const showCloneResults = (orchard) => {
      setClonedKpinName(orchard.input.kpin);
      setActionStatus(CLONE_STATUS_INITIALISE);
      setselectedOrchard(orchard);
      setModalOpen(true);
    };

    const showDeleteResults = (orchard) => {
      setActionStatus(DELETE_STATUS_INITIALISE);
      setselectedOrchard(orchard);
      setModalOpen(true);
    };


    const getOrchardEmissionsValue = (value,  productiveCanopyArea) => {
      if(!value) return "N/A"
      if(productiveCanopyArea > 0) {
        return value !== 0 ? value : 0;
      }  else {
        return "N/A"
      }     
    }

    return (
      <DisplayTableWrapper data-testid="orchard-results-table" type="summary">
        <DisplayTableHead type="summary-table">
          <DisplayTableRow>
            <DisplayTableHeaderCell isEmpty={true} />
            <DisplayTableHeaderCell isEmpty={true} />
            <DisplayTableHeaderCell isEmpty={true} />
            <DisplayTableHeaderCell colSpan={3} type={"borderLeft"}>
              Total per hectare emissions (kg CO2e/ha)
            </DisplayTableHeaderCell>
            <DisplayTableHeaderCell />
          </DisplayTableRow>
          <DisplayTableRow>
            <DisplayTableHeaderCell>KPIN</DisplayTableHeaderCell>
            <DisplayTableHeaderCell>Orchard name</DisplayTableHeaderCell>
            <DisplayTableHeaderCell>Season</DisplayTableHeaderCell>

            <DisplayTableHeaderCell  type={"borderLeft"}>Total</DisplayTableHeaderCell>
            <DisplayTableHeaderCell>Green</DisplayTableHeaderCell>
            <DisplayTableHeaderCell>Gold</DisplayTableHeaderCell>
            <DisplayTableHeaderCell>Actions</DisplayTableHeaderCell>
          </DisplayTableRow>
        </DisplayTableHead>

        <TableBody type="summary-table">
          {orchardData.map((orchard, i) => {
            const isDraft = orchard.result ? false : true;
             return (
              <DisplayTableRow key={`${orchard.input.shareId}-${i}`} type ={isDraft ? "draft" : ""}>
                <DisplayTableCell>
                  <InlineButton
                    onClick={() => {
                      navigateToResult(
                        orchard.input.shareId,
                        orchard.input.kpin
                      );
                    }}
                  >
                    {orchard.input.kpin}
                  </InlineButton>
                </DisplayTableCell>
                <DisplayTableCell>
                {`${orchard.input.calculatorDetails.orchardName} ${isDraft ? "(Draft)" : ""}`}
                </DisplayTableCell>
                <DisplayTableCell>{orchard.input.season}</DisplayTableCell>

                <DisplayTableCell>
                  {isDraft ? "" : orchard.result.results.total.totalPerHa || 0}
                </DisplayTableCell>
                <DisplayTableCell>
                  {isDraft ? "" : getOrchardEmissionsValue(orchard.result.results.total.totalGreenPerHa, orchard.input.varieties.green.productiveCanopyArea)}
               
                </DisplayTableCell>
                <DisplayTableCell>
                {isDraft ? "" : getOrchardEmissionsValue(orchard.result.results.total.totalGoldPerHa, orchard.input.varieties.gold.productiveCanopyArea)}
                </DisplayTableCell>
                <DisplayTableCell>
                    <ActionButtonBarWrapper>
                    {isDraft ?              (<InlineButton
                    onClick={() => {
                      resumeDraft(
                        orchard
                      );
                    }}
                  >
                    Continue
                  </InlineButton>):   (<InlineButton
                    onClick={() => {
                      navigateToResult(
                        orchard.input.shareId,
                        orchard.input.kpin
                      );
                    }}
                  >
                    View results
                  </InlineButton>)
                  }

                  <InlineButton
                    onClick={() => {
                      showCloneResults(orchard);
                    }}
                  >Clone</InlineButton> 
                   <InlineButton
                    onClick={() => {
                      showDeleteResults(orchard);
                    }}
                  >Delete</InlineButton> 
                    </ActionButtonBarWrapper>
                </DisplayTableCell>
              </DisplayTableRow>
            );
          })}
        </TableBody>
      </DisplayTableWrapper>
    );
  };

  return (
    <PageContainer>
      <Heading2 data-testid="summary-heading">Orchard Summary</Heading2>
      <ParagraphText>
        You have entered data for the following orchards. To view/edit an
        orchard, click on the orchard name.
      </ParagraphText>
      {loading ? (
        <LoadingModal data-testid="loading-spinner" />
      ) : (
        getOrchardTableData()
      )}
      <ButtonWrapper>
        <PrimaryButtonLink
          to={`../introduction`}
          onClick={() => {
            initialiseCalculation();
          }}
          disabled={false}
        >
          Create calculation for a new orchard
        </PrimaryButtonLink>
      </ButtonWrapper>
    </PageContainer>
  );
}
